import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';
import { Colors } from '../../../../../assets';
import { Spacing } from '../../../../../assets/GlobalStyle/Variables';
import { RequestsFormValues } from '../../models';

export const HistochemistryMakroForm: FC = () => {
  const { register } = useFormContext<RequestsFormValues>();

  return (
    <Wrapper>
      <Label>Požadované vyšetření</Label>
      <Textarea {...register('histochemistryRequestText' as any)} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing(2)};
`;

const Label = styled.div`
  color: ${Colors.grey};
  font-weight: 700;
`;

const Textarea = styled.textarea`
  width: 100%;
  min-height: 180px;
  border: 1px solid ${Colors.lightGrey};
  padding: ${Spacing(2)};
  resize: vertical;
`;
